import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Form} from "../../../shared/interface/form";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {FormAddService} from "../../../shared/services/form-add.service";

@Component({
  selector: 'app-dynamic-forms-details',
  templateUrl: './dynamic-forms-details.component.html',
  styleUrls: ['./dynamic-forms-details.component.scss']
})
export class DynamicFormsDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  dynamicFormId: string;
  dynamicFormObject?: Form;
  dynamicForm: ReplaySubject<Form> = new ReplaySubject<Form>(1);
  modify = false;
  constructor(
    private route: ActivatedRoute,
    private snack: MatSnackBar,
    private formService: FormAddService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.dynamicFormId = params.id;
        this.load();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  load(): void {
    this.formService.get(this.dynamicFormId).subscribe((formDictionary: Form) => {
      this.dynamicForm.next(formDictionary);
      this.dynamicFormObject = formDictionary;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
      this.router.navigate(['/formularze']);
    });
  }
}
